import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { getBufferReader } from './utils';
export function readJsonStream(_x) {
  return _readJsonStream.apply(this, arguments);
}
function _readJsonStream() {
  _readJsonStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var reader, doneStreaming, remainder, _yield$_awaitAsyncGen, value, done, processedChunks, _iterator, _step, chunk, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          reader = getBufferReader(response);
          doneStreaming = false;
          remainder = '';
        case 3:
          _context.prev = 3;
          _context.next = 6;
          return _awaitAsyncGenerator(reader.read());
        case 6:
          _yield$_awaitAsyncGen = _context.sent;
          value = _yield$_awaitAsyncGen.value;
          done = _yield$_awaitAsyncGen.done;
          doneStreaming = done;
          if (!value) {
            _context.next = 43;
            break;
          }
          _context.prev = 11;
          processedChunks = "".concat(remainder).concat(value).split('\n'); // assumes that all JSON chunks are separated by a new-line;
          remainder = '';
          _iterator = _createForOfIteratorHelper(processedChunks);
          _context.prev = 15;
          _iterator.s();
        case 17:
          if ((_step = _iterator.n()).done) {
            _context.next = 29;
            break;
          }
          chunk = _step.value;
          _context.prev = 19;
          _context.next = 22;
          return JSON.parse(chunk);
        case 22:
          _context.next = 27;
          break;
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](19);
          // the chunk may be incomplete, so we'll save it for the next iteration.
          remainder = chunk;
        case 27:
          _context.next = 17;
          break;
        case 29:
          _context.next = 34;
          break;
        case 31:
          _context.prev = 31;
          _context.t1 = _context["catch"](15);
          _iterator.e(_context.t1);
        case 34:
          _context.prev = 34;
          _iterator.f();
          return _context.finish(34);
        case 37:
          _context.next = 43;
          break;
        case 39:
          _context.prev = 39;
          _context.t2 = _context["catch"](11);
          error = new Error("Error Processing Stream Data: ".concat(value));
          throw error;
        case 43:
          _context.next = 52;
          break;
        case 45:
          _context.prev = 45;
          _context.t3 = _context["catch"](3);
          if (!(_context.t3 instanceof DOMException && _context.t3.name === 'AbortError')) {
            _context.next = 51;
            break;
          }
          doneStreaming = true;
          _context.next = 52;
          break;
        case 51:
          throw _context.t3;
        case 52:
          if (!doneStreaming) {
            _context.next = 3;
            break;
          }
        case 53:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 45], [11, 39], [15, 31, 34, 37], [19, 24]]);
  }));
  return _readJsonStream.apply(this, arguments);
}